/* global apntag */
import config from 'player/config';
import utils from 'utils/utils';

export default utils.extend({
    load: function () {
        // load this only once
        if (!window.apntag) {
            return utils.loadScript(config.ads.appnexus.ast);
        }

        return Promise.resolve();
    },

    defineTag: function (tagId, tagOptions) {
        return this.load().then(function () {
            const tagConfig = utils.merge({
                targetId: tagId
            }, tagOptions);


            apntag.debug = config.ads.appnexus.debug;
            // apntag tag overriden by reference
            apntag.defineTag(utils.extend({}, tagConfig));

            apntag.loadTags(tagId);
            apntag.onEvent('adLoaded', tagId, this.trigger.bind(this, 'adLoaded', tagId));
        }.bind(this));
    },

    showTag: function (tagId) {
        apntag.showTag(tagId);
    },

    refreshTag: function (tagId) {
        apntag.refresh([tagId]);
    },

    resizeTag: function (tagId, dimmensions) {
        const size = [
            parseInt(dimmensions[0], 10),
            parseInt(dimmensions[1], 10)
        ];

        if (window.apntag) {
            apntag.resizeAd(tagId, size);
        }
    },

    off: function (targetId) {
        apntag.offEvent('adLoaded', targetId);
    }
}, utils.Events);
